import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/hosts/useHostsQueryKeys.ts
var t = e("hosts", {
	profile: (e) => ["profile", e],
	listings: (e, t, n) => [
		"listings",
		e,
		t ?? "",
		n ?? ""
	],
	listingGroups: (e, t) => t ? [
		"listingGroups",
		e,
		t
	] : ["listingGroups", e]
});
//#endregion
export { t as hostQueryKeys };
